import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { push } from 'connected-react-router';

// Components
import { App } from '../../../App';
import { FullScreenLoader } from '../../../components/Loaders/FullScreenLoader';
import { RevisionSelector } from '../../../components/Publishing/RevisionSelector';

// Styles
import { SmartContainer, Surface } from '../../../styles/Containers'

// Redux
import { AssetsList } from '../Assets/AssetsList';
import { hasAccess, useActiveItem } from '../../services/CaptureCollabService';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconSettings } from '../../Icons';
import { StyledFullScreenModal } from '../../components/Content/FullScreenModal';
import { AssetViewer } from '../Assets/AssetViewer';
import { FullViews } from './redux/views.selectors';
import { getView } from './redux/views.actions';
import { Role } from '../../../redux/Auth/auth.selectors';
import { searchPermissions, useMyPermissions } from '../Permission/redux/permissions.actions';
import { PermissionsEditor } from '../Permission/PermissionsEditor';
import { FullPermissions } from '../Permission/redux/permissions.selectors';
import { NoPermissions } from '../Permission/NoPermissions';
import { ViewAssetsList } from './ViewAssetslist';


export const ViewPage = () => {

    // New Modal
    const dispatch = useDispatch();
    const store = FullViews();
    const { id } = useParams();

    const [filters, setFilters] = useState(null);
    const { activeItem, setActiveItem } = useActiveItem({ id, model: 'View', selector: FullViews, getAction: getView })

    // Permissions
    const currentUserRole = Role();
    const { permissions, hasPermission, getPermissionRole, permissionChecked } = useMyPermissions();
    const [noAccess, setNoAccess] = useState(false);
    const [myRole, setMyRole] = useState(null);

    // --------------------------
    // Effects
    // --------------------------

    // Get This Item
    useEffect(() => {
        // Set The Filters
        if (activeItem?.meta?.filters) {
            setFilters(activeItem.meta.filters)
        }
        else setFilters(null);
    }, [activeItem]);

    // Check Permissions
    useEffect(() => {
        if (hasPermission('View', id)) {
            const r = getPermissionRole('View', id);
            setNoAccess(false);
            setMyRole(r);
        } else {
            setNoAccess(true);
        }

    }, [permissions])


    // --------------------------
    // Interactions
    // --------------------------

    const handleSelect = (item) => {
        dispatch(push(`/asset/${item.id}`))
        // setActiveAsset(item);
        // setOpenViewer(true);
    }

    const renderTopBarChildren = () => {

        if (noAccess) return null;

        return (
            <SmartContainer flex align="center" justify="flex-end">
                {id && activeItem && (myRole === 'owner' || myRole === 'admin') && (
                    <PermissionsEditor
                        modelId={activeItem?.id}
                        model="View"
                        selector={FullPermissions}
                        action={searchPermissions}
                    />
                )}
                {id && (myRole === 'owner' || myRole === 'admin') && (<StyledIconButton onClick={() => dispatch(push(`/views/${id}/settings`))}><IconSettings /></StyledIconButton>)}
            </SmartContainer>
        )

    }

    const formatFilters = (f) => {

        const fom = {}

        const x = Object.keys(f)?.map(key => {

            if (filters[key].length > 0) {
                if (key.indexOf('Compare') > 0) {
                    fom[key] = filters[key];
                } else {
                    fom[key] = JSON.stringify(filters[key]);
                }
            }
            return key;
        })

        return fom;
    }
    // --------------------------
    // Renders
    // --------------------------


    // Render Page
    const viewName = (activeItem?.name) ? activeItem?.name : 'Loading';

    return (
        <App title={viewName}
            topBarChildren={renderTopBarChildren()}
            breadcrumbs={[{ href: `/views`, title: 'Views' }]}
        >
            {!activeItem && (<FullScreenLoader />)}
            {activeItem && (
                <SmartContainer width="100%">

                    {(noAccess || permissionChecked === 'notchecked') && (<NoPermissions checked={permissionChecked} />)}

                    {filters && (!noAccess && permissionChecked !== 'notchecked') && (myRole === 'owner' || myRole === 'admin') && (<AssetsList onSelect={handleSelect} filters={formatFilters(filters)} hideControls={true} myRole={myRole} />)}
                    {filters && (!noAccess && permissionChecked !== 'notchecked') && (myRole === 'viewer' || myRole === 'collaborator' || myRole === 'editor') && (<ViewAssetsList view={activeItem} myRole={myRole} />)}

                </SmartContainer>
            )}
        </App>
    )
}